import script from "./AppBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./AppBottomNav.vue?vue&type=style&index=0&id=0ced53bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ced53bd"]])

export default __exports__